import { useEffect, useRef, useState } from "react";

const Section = ({ background, color, title, description, img, video, titleClassName }) => {
  const videoRef = useRef(null);
  const [videoLoaded, setVideoLoaded] = useState(false);

  useEffect(() => {
    if (video && videoRef.current) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // Set the video src lazily when the video comes into view.
              videoRef.current.src = video;
              videoRef.current.play();
              setVideoLoaded(true);
              observer.unobserve(videoRef.current);
            }
          });
        },
        { threshold: 0.5 }
      );
      observer.observe(videoRef.current);

      return () => {
        observer.disconnect();
      };
    }
  }, [video]);

  return (
    <div
      className="section d-flex text-center"
      style={{ background: background, color: color }}
    >
      <div className="d-block d-md-flex justify-content-between p-2 m-auto col-10">
        <div
          className="my-md-auto text-justify p-0 col-12 col-md-6"
          style={{ height: "fit-content" }}
        >
          <h1
            className={`mb-5 ${titleClassName || ""}`}
            style={{
              fontFamily: "'Cinzel', serif",
              fontWeight: 200,
            }}
          >
            {title}
          </h1>
          <h3 className="mb-5">{description}</h3>
        </div>
        <div
          className="m-auto ml-md-auto fade-in-section"
          style={{
            height: "410px",
            width: "300px",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {video ? (
            <video
              ref={videoRef}
              muted
              preload="none"
              poster={img}
              style={{ height: "100%", width: "100%" }}
              controls={false}
            />
          ) : (
            <div
              style={{
                height: "100%",
                width: "100%",
                backgroundImage: `url(${img})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            ></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Section;